import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { ColumnMode, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';

/**
 *  GONDVISELŐK.
 *
 *  A képernyő eddig CSAK listázott: a modál mentés gombja üres függvényre futott,
 *  a mezői pedig egy másik adatlapról másolt mezőnevek voltak (oktatási azonosító,
 *  anyanyelv, állampolgárság) – olyanok, amiket a gondviselő nyilvántartása nem is
 *  tárol. Gondviselőt tehát a felületről nem lehetett felvenni vagy módosítani,
 *  csak importból.
 *
 *  Az adatlap ezért a VALÓDI mezőkre épül. Kevesebb mező, de mind működik – ez
 *  többet ér, mint egy teljesnek látszó űrlap, ami nem ment el semmit.
 */
@Component({
  selector: 'app-szulok',
  templateUrl: './szulok.component.html',
  styleUrls: ['./szulok.component.scss'],
})
export class SzulokComponent implements OnInit {

  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly SelectionType = SelectionType;

  sajatIntezmeny: any;
  allomany: any[] = [];
  selected: any[] = [];
  toltodik = false;
  ment = false;

  /** A szerkesztett gondviselő (üres = új felvétel). */
  urlap: any = null;

  @ViewChild('uzenetmodal') modal: IonModal;

  /** Keresés a listában – név, felhasználónév, e-mail. */
  kereses = '';

  /*  SZÜLŐI FELÜGYELETI JOG gyermekenként (backend/felugyeleti-jog.js, Nkt. 41. § (11)–(12)). A jelölés a szülő
   *  hozzáférését és értesítéseit a kiszolgálón szűkíti (2026-11-02); alapból mindenki „teljes”. A gondviselő
   *  adatlapjának mentésétől független, soronként ment. */
  readonly felugyeletAllapotok = [
    { kod: 'teljes', nev: 'Teljes (gyakorolja)' },
    { kod: 'nem_gyakorlo', nev: 'Felügyeleti jogot nem gyakorló' },
    { kod: 'korlatozott', nev: 'Korlátozott' },
    { kod: 'megvont', nev: 'Megvont (szünetel)' },
  ];
  kapcsolatok: any[] = [];
  felugyeletMigracio = true;
  felugyeletMent = '';

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    this.betolt();
  }

  getRowClass = () => ({});

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  get szurtLista(): any[] {
    const k = this.kereses.trim().toLowerCase();
    if (!k) return this.allomany;
    return this.allomany.filter((r) =>
      `${r.full_name || ''} ${r.username || ''} ${r.email || ''}`.toLowerCase().includes(k));
  }

  betolt() {
    if (!this.sajatIntezmeny?.intezmenyId) return;
    this.toltodik = true;
    this.http.get<any[]>(`/api/nyilvantartas/szulo/${this.sajatIntezmeny.intezmenyId}`,
      { headers: { intezmeny: this.sajatIntezmeny.intezmenyId } })
      .subscribe({
        next: (r) => { this.allomany = Array.isArray(r) ? r : []; this.toltodik = false; },
        error: () => {
          this.allomany = [];
          this.toltodik = false;
          this.data.sendToast('A gondviselők listája nem tölthető be.', 'error');
        },
      });
  }

  /** Üres adatlap – új gondviselő. */
  uj() {
    this.urlap = {
      id: null, elo: '', vez: '', ker: '', torv_kepv: 1,
      szul_hely: '', szul_ido: '', anya_vez: '', anya_ker: '',
      username: '', email: '', telefon: '',
      irsz: null, telepules: '', cim: '',
      tart_irsz: null, tart_telepules: '', tart_cim: '',
      ig_tipus: '', ig_szam: '',
    };
    this.modal.present();
  }

  /** Meglévő gondviselő megnyitása szerkesztésre. */
  szerkeszt(row: any) {
    this.urlap = {
      id: row.id, elo: row.elo || '', vez: row.vez || '', ker: row.ker || '',
      torv_kepv: Number(row.torv_kepv) ? 1 : 0,
      szul_hely: row.szul_hely || '',
      szul_ido: this.nap(row.szul_ido),
      anya_vez: row.anya_vez || '', anya_ker: row.anya_ker || '',
      username: row.username || '', email: row.email || '', telefon: row.telefon || '',
      irsz: row.irsz ?? null, telepules: row.telepules || '', cim: row.cim || '',
      tart_irsz: row.tart_irsz ?? null, tart_telepules: row.tart_telepules || '',
      tart_cim: row.tart_cim || '',
      ig_tipus: row.ig_tipus || '', ig_szam: row.ig_szam || '',
      gyermekek: (row.gyermekek || []).filter(Boolean),
    };
    this.kapcsolatok = [];
    if (row.username) this.felugyeletBetolt(row.username);
    this.modal.present();
  }

  /** A gondviselő gyermek-kapcsolatai a felügyeleti állapottal. */
  felugyeletBetolt(username: string) {
    const int = this.sajatIntezmeny?.intezmenyId;
    if (!int) return;
    this.http.get<any>(`/api/felugyeleti-jog/kapcsolatok/${int}`, { params: { szulo: username } }).subscribe({
      next: (r) => {
        this.felugyeletMigracio = r?.migracio !== false;
        this.kapcsolatok = (Array.isArray(r?.kapcsolatok) ? r.kapcsolatok : [])
          .map((k: any) => ({ ...k, uj_allapot: k.felugyeleti_jog, uj_megjegyzes: k.felugyeleti_megjegyzes || '' }));
      },
      error: () => { this.kapcsolatok = []; },
    });
  }

  felugyeletValtozott(k: any): boolean {
    return k.uj_allapot !== k.felugyeleti_jog || String(k.uj_megjegyzes || '') !== String(k.felugyeleti_megjegyzes || '');
  }

  felugyeletMentes(k: any) {
    if (this.felugyeletMent) return;
    if (k.uj_allapot !== 'teljes' && !String(k.uj_megjegyzes || '').trim()) {
      this.data.sendToast('Add meg az alapját (pl. a bírósági vagy gyámhatósági döntés száma, kelte).', 'warning');
      return;
    }
    this.felugyeletMent = k.id;
    this.http.put(`/api/felugyeleti-jog/${this.sajatIntezmeny.intezmenyId}`,
      { id: k.id, allapot: k.uj_allapot, megjegyzes: String(k.uj_megjegyzes || '').trim() }).subscribe({
      next: () => {
        this.felugyeletMent = '';
        this.data.sendToast('Felügyeleti jog mentve.', 'success');
        if (this.urlap?.username) this.felugyeletBetolt(this.urlap.username);
      },
      error: (e) => {
        this.felugyeletMent = '';
        this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
      },
    });
  }

  /** ISO dátum a `type="date"` mezőnek – enélkül a mező üresen nyílna meg. */
  private nap(d: any): string {
    if (!d) return '';
    const s = String(d);
    return /^\d{4}-\d{2}-\d{2}/.test(s) ? s.slice(0, 10) : '';
  }

  /** A tartózkodási cím átvétele az állandóból – a legtöbbször ugyanaz. */
  cimMasol() {
    if (!this.urlap) return;
    this.urlap.tart_irsz = this.urlap.irsz;
    this.urlap.tart_telepules = this.urlap.telepules;
    this.urlap.tart_cim = this.urlap.cim;
  }

  cancel() {
    this.urlap = null;
    this.modal.dismiss(null, 'cancel');
  }

  mentes() {
    if (this.ment || !this.urlap) return;
    const u = this.urlap;
    if (!String(u.vez).trim() || !String(u.ker).trim()) {
      this.data.sendToast('A vezetéknév és a keresztnév kötelező.', 'warning');
      return;
    }
    if (!String(u.username).trim()) {
      this.data.sendToast('A belépési azonosító kötelező – ezzel lép be a gondviselő.', 'warning');
      return;
    }

    this.ment = true;
    const { gyermekek, ...mentendo } = u;
    this.http.post('/api/nyilvantartas/szulo/save', {
      szulo: { ...mentendo, szul_ido: u.szul_ido || null, intezmeny: this.sajatIntezmeny.intezmenyId },
    }).subscribe({
      next: () => {
        this.ment = false;
        this.data.sendToast('Mentve.', 'success');
        this.urlap = null;
        this.modal.dismiss(null, 'confirm');
        this.betolt();
      },
      error: (e) => {
        this.ment = false;
        this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
      },
    });
  }

  /*  Törlés. A gyerek-hozzárendeléssel rendelkező gondviselőt a kiszolgáló nem
   *  engedi törölni – azt itt is kimondjuk, mielőtt bárki rákattint. */
  torol(row: any) {
    const gyerekDb = (row.gyermekek || []).filter(Boolean).length;
    const kerdes = gyerekDb
      ? `${row.full_name} törlése előtt le kell venni róla a(z) ${gyerekDb} gyereket. Megpróbálod?`
      : `Biztosan törlöd: ${row.full_name}?`;
    if (!confirm(kerdes)) return;
    this.http.delete(`/api/nyilvantartas/szulo/${row.id}`).subscribe({
      next: () => { this.data.sendToast('Törölve.', 'success'); this.betolt(); },
      error: (e) => this.data.sendToast(e?.error?.error || 'A törlés nem sikerült.', 'error'),
    });
  }
}
